import React, { useEffect, useState } from "react";
import { Type } from "lucide-react";

const STEPS = [
  { key: "normal", label: "A", pct: 100 },
  { key: "large", label: "A+", pct: 115 },
  { key: "xlarge", label: "A++", pct: 130 },
];
const KEY = "s360-font-size-v2";

export function applyFontSize(key) {
  const step = STEPS.find((s) => s.key === key) || STEPS[0];
  document.documentElement.style.fontSize = `${step.pct}%`;
}

export function FontSizeToggle() {
  const [key, setKey] = useState(() => localStorage.getItem(KEY) || "normal");

  useEffect(() => {
    applyFontSize(key);
    localStorage.setItem(KEY, key);
  }, [key]);

  const idx = STEPS.findIndex((s) => s.key === key);
  const next = STEPS[(idx + 1) % STEPS.length];
  const cur = STEPS[idx] || STEPS[0];

  return (
    <button
      data-testid="font-size-toggle"
      onClick={() => setKey(next.key)}
      aria-label={`Text size: ${cur.label}. Click for ${next.label}`}
      title={`Text size: ${cur.label}`}
      className="flex items-center gap-1.5 border border-line2 px-3 h-8 font-mono-data text-xs uppercase tracking-wider text-ftext2 hover:text-sky hover:border-sky transition-colors"
    >
      <Type className="w-3.5 h-3.5" />
      <span data-testid="font-size-level" className="font-bold">{cur.label}</span>
    </button>
  );
}
